export const tr = {
    'interest-type-all': 'herhangi bir dönem',
    'interest-type-long-term': 'uzun vadeli',
    'interest-type-short-term': 'kısa vadeli',
    interests: 'İlgi alanları'
};
